<p class="text-12 text-center">
  When calculating the biggest saving, we have relied on the information which you provided to us
  when you last updated your Mortgage Monitor account.
  <br />
  <br />
  If your needs or circumstances have changed since then please update your information or speak to
  a qualified mortgage advisor before acting on this advice. We will let you know if your updated
  information changes our recommendation.
  <br />
  <br />
  Think carefully before securing other debts against your home. Your home or property may be
  repossessed if you do not keep up repayments on your mortgage.
</p>
